import * as React from 'react';

type IconUserLoggedProps = React.SVGProps<SVGSVGElement>;

export const IconUserLogged: React.FC<IconUserLoggedProps> = (props) => (
	<svg width={42} height={42} viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<circle cx="21" cy="21" r="21" fill="#7EAE90"/>
		<path d="M29.4 29.9095C29.4 34.8302 9.80005 34.8302 9.80005 29.9095C9.80005 24.9889 14.1877 21 19.6 21C25.0124 21 29.4 24.9889 29.4 29.9095Z" fill="#EBF8F0"/>
		<circle cx="19.5996" cy="15.4004" r="7" fill="#EBF8F0"/>
		<path d="M22.4004 30.3335L25.964 33.6002L33.6004 25.2002" stroke="#FFA692" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>

);

